import kebabCase from 'lodash/kebabCase'
import * as React from 'react'

import DividerComp from '../../components/DividerComp/DividerComp'
import HeadingWithImg from '../../components/HeadingWithImg/HeadingWithImg'
import AccordionItem from '../../components/OptionAccordions/AccordionItem/AccordionItem'
import OptionAccordions from '../../components/OptionAccordions/OptionAccordions'
import type { ImageViewModel } from '../../view-models/ImageViewModel'
import type { OptionAccordionsViewModel } from '../../view-models/OptionAccordionsViewModel'
import styles from './accordion-style.css'

export type AccordionProps = {
  items: Array<OptionAccordionsViewModel>
  title: string
  avatar?: ImageViewModel
  icon?: string
  id?: string

  /*will be sent by backend for the Anchor Points*/
  hideDivider?: boolean
}
type State = {}

class Accordion extends React.Component<AccordionProps, State> {
  static displayName = 'Accordion'
  static defaultProps = {}

  render() {
    const { items, title, avatar, icon, id, hideDivider } = this.props
    if (!items) return null

    return (
      <div className={styles.accordion} id={id || ''}>
        {title && (
          <div className={styles.headingWrapper}>
            <HeadingWithImg title={title} icon={icon} image={avatar} />
          </div>
        )}
        <OptionAccordions
          eventName={'accordion'}
          items={items}
          renderItems={(items, handleClick, currentIndex) => {
            return items.map((item, index) => (
              <React.Fragment key={item.title}>
                <AccordionItem
                  id={`item-${index}__${kebabCase(item.title)}`}
                  item={item}
                  open={currentIndex === index}
                  onClick={handleClick}
                  index={index}
                />
              </React.Fragment>
            ))
          }}
        />
        {!hideDivider && <DividerComp />}
      </div>
    )
  }
}

export default Accordion